<div *ngIf="quote && quoteAcknowledgements" class="container-fluid">
    <div class="row">
        <div class="col-md-10">
            <h3 *ngIf="!quote.quote_Converted" i18n>Quote Acknowledgements</h3>
            <h3 *ngIf="quote.quote_Converted" i18n>Acknowledgements</h3>
            <p *ngIf="!quote.quote_Converted" i18n>List of acknowledgements for quote.</p>
            <p *ngIf="quote.quote_Converted" i18n>List of acknowledgements for quotes/change orders.</p>
        </div>
    </div>

    <div class="row">
        <div class="col-12">&nbsp;</div>
    </div>
    <table class="table table-bidit table-striped">
        <thead>
            <tr>
                <th>Acknowledgement ID</th>
                <th i18n>Status</th>
                <th i18n>Date Sent</th>
                <th i18n>Date Acknowledged</th>
                <th i18n>Accepted Quote Rejected on</th>
                <th i18n>Expiry Date</th>
                <th></th>
            </tr>
        </thead>

        <tbody>
            <tr *ngIf="this.quoteAcknowledgements.length == 0">
                <td colspan="6">
                    <h5 *ngIf="!quote.quote_Converted" i18n>No acknowledgements exist for this quote</h5>
                    <h5 *ngIf="quote.quote_Converted" i18n>No acknowledgements exist for quotes/change orders</h5>
                </td>
            </tr>
            <tr *ngFor="let acknowledgement of quoteAcknowledgements">
                <td>
                    {{acknowledgement.quoteAcknowledgement_ID}}
                    <span *ngIf="quote.quote_Converted != undefined">{{changeOrderLabel(acknowledgement.changeOrder_ID)}}</span>
                </td>
                <td>
                    {{acknowledgement.acknowledgementStatusDesc}}
                </td>
                <td>
                    {{acknowledgement.dateSent  | date:'MM/dd/yyyy  HH:mm:ss'}}
                </td>
                <td>
                    {{acknowledgement.acknowledgedDate | date:'MM/dd/yyyy  HH:mm:ss'}}
                </td>
                <td>
                    {{acknowledgement.acceptedQuoteRejectedDate | date:'MM/dd/yyyy  HH:mm:ss'}}
                </td>
                <td>
                    {{acknowledgement.acknowledgedDate != null ? '' : acknowledgement.expiryDate | date:'MM/dd/yyyy HH:mm:ss'}}
                </td>
                <td>
                  <button *ngIf="acknowledgement.acknowledgedDate != null"  (click)="downloadAttachment(acknowledgement)" class="btn btn-bidit-navigate mr-1" i18n>Download</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
